<template>
  <Layout>
    <Header class="header">
      <Breadcrumb class="breadcrumb">
        <BreadcrumbItem>发布推送消息</BreadcrumbItem>

      </Breadcrumb>
    </Header>
    <Content>
      <Form ref="dataForm" :model="formData" :rules="rules" :label-width="80" style="width: 95%">


        <row>
          <FormItem label="内容：" prop="content">
            <Input v-model="formData.content" :rows="3" maxlength="1000" show-word-limit type="textarea"
                   placeholder="请输入内容"/></FormItem>
        </row>


        <row>
          <Col>
            <FormItem label="标题：" prop="title">
              <Input v-model="formData.title" class="input" placeholder="请输入标题"/>
            </FormItem>
          </Col>
        </row>

        <row>
          <Col span="12">
            <FormItem label="类型：" prop="type">
              <Input v-model="formData.type" class="input" placeholder="请输入类型"/>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="密码：" prop="password">
              <Input v-model="formData.password" class="input" placeholder="请输入密码"/>
            </FormItem>
          </Col>
        </row>

        <FormItem>
          <Button type="primary" @click="submit">发送</Button>
        </FormItem>

      </Form>
    </Content>
  </Layout>
</template>
<script>
import Vue from 'vue'
import request from '@/utils/request'

export default Vue.extend({
  data() {
    return {
      rawContent: '',
      formData: {
        content: '',
        title: '',
        type: '',
        password: '',
      },
      fixConent: '',
      rules: {
        title: [{required: true, message: '标题不能为空', trigger: 'change'}],
        type: [{required: true, message: '类型不能为空', trigger: 'change'}],
        content: [{required: true, message: '内容不能为空', trigger: 'change'}],
        password: [{required: true, message: '操作密码不能为空', trigger: 'change'}],
      },
    }
  },
  watch: {

    'formData.content': function(val) {

      if (this.rawContent === '') {
        this.rawContent = val
      }


      if (val === this.rawContent) {
        const vals = val.split('：')
        if (vals.length > 0 && val.indexOf('鄠邑区气象台') >= 0) {
          this.formData.title = vals[0]
          this.formData.content = this.formData.content.replace(this.formData.title + '：', '')

          if (this.formData.title.indexOf('天气预报') >= 0) {
            this.formData.type = '天气预报'
          } else if (this.formData.title.indexOf('重要天气报告') >= 0) {
            this.formData.type = '重要天气报告'
          } else if (this.formData.title.indexOf('专题预报') >= 0) {
            this.formData.type = '专题预报'
          } else {
            this.formData.type = ''
          }
        }
      }
    },
  },
  methods: {
    submit() {


      const params = this.formData
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          request.post('/wechatServ/sendToWechatByhuyi', params)
              .then((res) => {
                if (res === true) {
                  this.$Message.success('发送成功!')
                  this.$refs.dataForm.resetFields();
                } else {
                  this.$Message.error('密码错误，请重新输入!')
                }
              })
        }
      })
    },
  },
})
</script>
<style scoped>
.content {
  display: flex;
  justify-content: center;
}

form {
  width: 650px;
}

.typeAll {
  display: flex;
}
</style>
